
if ( document.getElementById("qtyMinus") ) {
  document.getElementById("qtyMinus").addEventListener("click", function() {
    
    var inputEl = document.getElementById("product-quantity-input");
    var inputVal = inputEl.value;

    if (inputVal > 1) {
      var newValue = inputVal - 1;
    } else {
      var newValue = 0;
    }

    document.getElementById("product-quantity-input").value = newValue;

  });
}

if ( document.getElementById("qtyPlus") ) {
  document.getElementById("qtyPlus").addEventListener("click", function() {
    
    var inputEl = document.getElementById("product-quantity-input");
    var inputVal = inputEl.value;
	var newValue = parseInt(inputVal) + 1;
    
    document.getElementById("product-quantity-input").value = newValue;

  });
}